export function InfinityIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22 12c0-2.761-2.189-5-4.889-5C14.844 7 13.044 8.434 12 9.824 10.956 8.434 9.156 7 6.889 7 4.189 7 2 9.239 2 12s2.189 5 4.889 5c2.267 0 4.067-1.434 5.111-2.824C13.044 15.566 14.844 17 17.111 17c2.7 0 4.889-2.239 4.889-5zM4 12c0 1.7 1.336 3 2.889 3 1.124 0 2.168-.578 3-1.43.408-.416.717-.853.914-1.216.089-.163.139-.28.166-.354a2.868 2.868 0 00-.166-.354 5.665 5.665 0 00-.914-1.216C9.057 9.578 8.013 9 6.89 9 5.336 9 4 10.3 4 12zm16 0c0 1.7-1.335 3-2.889 3-1.124 0-2.168-.578-3-1.43a5.664 5.664 0 01-.914-1.216A2.868 2.868 0 0113.03 12c.027-.073.077-.19.166-.354.197-.363.506-.8.914-1.216.832-.852 1.876-1.43 3-1.43C18.664 9 20 10.3 20 12z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
